
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3>{`Email me for a quote/to order!`}</h3>
    <p>{`Thank you for your interest in my commissions!`}</p>
    <p>{`If you would like to order now or get a quote please send me a detailed message
explaining which commission type you are interested in, what you’d like the
character(s) doing, background setting (if applicable), character references and
any other information that might be important.`}</p>
    <p>{`Please ensure that the email address you are contacting me with is the email
address linked to your PayPal. You will be sent an invoice via PayPal once your
commission request has been approved.`}</p>
    <p>{`If you would like your commission to be kept private (not uploaded anywhere on
social media) or is urgently needed please let me know!`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;